import { Box, BoxProps, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { FC, useEffect, useRef, useState } from 'react'
import { GestureResponderEvent, TouchableHighlight, View, ViewStyle } from 'react-native'
import { Colors } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { ModalView } from './ModalView'

export interface DataType {
  id: string
  value: string
}
interface MultiselectDropdownProps {
  hide?: boolean
  selectedData?: (values: any) => void
  data: Array<DataType>
  placeHolder?: string
  label?: string
  error?: string
  touched?: boolean
  value?: any
  fieldName?: string
  setFieldValue?: (fieldName: string, value: Array<string>) => void
  isMultiSelect?: boolean
  checkboxColor?: ColorOptions
  width?: number
  fontFamily?: string
  selectedTextBackgroundClor?: ColorOptions
  selectedTextBorderColor?: ColorOptions
  modelMaxHeight?: number
  allValues?: any
  testID?: string
  scrollViewId?: string
  disabled?: boolean
  selectAll?: boolean
}

const MultiselectDropdown: FC<MultiselectDropdownProps> = ({
  hide,
  selectedData,
  data,
  fieldName,
  placeHolder = 'Select',
  label,
  setFieldValue,
  touched,
  error,
  value,
  isMultiSelect = false,
  selectAll = false,
  checkboxColor = 'BLACK_LIGHT',
  fontFamily,
  selectedTextBackgroundClor,
  selectedTextBorderColor,
  modelMaxHeight = 200,
  allValues,
  disabled = false,
  testID,
  scrollViewId = '',
}: MultiselectDropdownProps) => {
  const [showDropdown, setShowDropdown] = useState(false)

  const [measureInfo, setMeasureInfo] = useState({ x: 0, y: 0, width: 0, height: 0, pageX: 0, pageY: 0 })
  let dopdownViewRef: any = useRef(null)

  const [selData, setTextTitle] = useState([])
  const [lessData, setLessData] = useState([])

  const getTitle = () => {
    return value?.length > 0 ? value?.toString()?.split(',') : []
  }

  useEffect(() => {
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, selData?.length === 0 ? getTitle() : undefined)
    }
    if (selectedData) {
      selectedData('')
      setTextTitle([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allValues?.paymode])

  useEffect(() => {
    const d = getTitle()
    setTextTitle(d)
    const lessLength = measureInfo.width > 0 ? Math.floor((measureInfo.width - 120) / 90) : 2
    const newData: any = [...d].splice(0, lessLength)
    setLessData(newData)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  if (hide) {
    return null
  }

  const dismissDropDown = () => {
    setShowDropdown(false)
  }

  const onSelected = (item: any) => {
    if (setFieldValue && fieldName && item) {
      setFieldValue(fieldName, item?.join(','))
    }
    if (selectedData && item) {
      selectedData(item?.join(','))
      // setTextTitle(item?.join(','))
    }
  }

  const renderValues = () => {
    if (!isMultiSelect) {
      return (
        <Box f={1}>
          <Text type="h3Bold" color="BLACK_21" fontWeight="700" numberOfLines={1}>
            {value}
          </Text>
        </Box>
      )
    }

    const onClear = (cleanValue: any) => {
      const cleanData = selData.filter((item) => item !== cleanValue)

      if (setFieldValue && fieldName && cleanData) {
        setFieldValue(fieldName, cleanData)
      }
      if (selectedData && cleanData) {
        selectedData(cleanData.join(','))
        setTextTitle(cleanData)
      }
    }

    const detailView = lessData.length
      ? lessData.map((item: any, index: number) => {
          if (item?.length === 0) {
            return null
          }
          return (
            <Box
              {...styles.textContainer}
              key={`${item}-${index}`}
              backgroundColor={selectedTextBackgroundClor}
              borderColor={selectedTextBorderColor}>
              <Text
                type="h5"
                testID={'instrument-' + item}
                color={checkboxColor}
                fontWeight="700"
                numberOfLines={1}
                fontFamily={fontFamily}>
                {item}
              </Text>
              <Spacer size={8} direction="horizontal" />
              <Box
                testID="clear"
                onPress={() => onClear(item)}
                alignItems="center"
                underlayColor="TRANSPARENT"
                disabled={disabled}>
                <Icon id="CLEAR" size="FONT_SIZE_TINY" color={checkboxColor} />
              </Box>
            </Box>
          )
        })
      : undefined

    return (
      <Box flexDirection="row" justify="space-between" alignItems="center" flexGrow={1}>
        <Box flexDirection="row">{detailView}</Box>
        {selData.length ? (
          <Box flexDirection="row" alignItems="center">
            {selData.length > lessData.length && (
              <Box flexDirection="row">
                <Box flexDirection="row">
                  <Text type="h1Bold" color={checkboxColor} fontWeight="900" textAlign="center">
                    {'...'}
                  </Text>
                </Box>
                <Spacer size={8} direction="horizontal" />
                <Box backgroundColor={checkboxColor} ph={6} pv={3} alignSelf="center" borderRadius={4}>
                  <Text testID="instrument-count" type="h4Bold" color="WHITE" fontWeight="700">
                    {selData?.length - lessData?.length ?? 0}
                  </Text>
                </Box>
                <Spacer size={4} direction="horizontal" />
              </Box>
            )}
            {!disabled && (
              <Box testID="clearAll" onPress={onClearAll} underlayColor="TRANSPARENT">
                <Text
                  title={'Clear All'}
                  color={checkboxColor}
                  fontFamily={'jiotype-medium'}
                  fontSize={12}
                  textDecorationLine={'underline'}
                />
              </Box>
            )}
          </Box>
        ) : undefined}
      </Box>
    )
  }

  const onClearAll = () => {
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, [])
    }
    if (selectedData) {
      selectedData('')
      setTextTitle([])
    }
  }

  const dropdownTapped = (evt: GestureResponderEvent): void => {
    if (evt) {
      dopdownViewRef?.current?.measure((x: any, y: any, width: any, height: any, pageX: any, pageY: any) => {
        setMeasureInfo({ x, y, width, height, pageX, pageY: pageY + 16 })
      })
      !!data && data?.length > 0 && setShowDropdown((prev) => !prev)
    }
  }

  const onLayout = (event: any) => {
    const { width } = event.nativeEvent.layout
    console.log('***** width: ', width)
    if (dopdownViewRef) {
      dopdownViewRef?.current?.measure((x: any, y: any, boxwidth: any, height: any, pageX: any, pageY: any) => {
        setMeasureInfo({ x, y, width: boxwidth, height, pageX, pageY: pageY + 16 })
      })
    }
  }
  return (
    <Box f={1}>
      <ModBox show={!!label}>
        <Text
          title={label}
          fontFamily={'jiotype-medium'}
          fontSize={12}
          color={Colors.LABEL_GREY as ColorOptions}
          lineHeight={20}
        />
        <Spacer direction={'vertical'} size={8} />
      </ModBox>
      <View ref={dopdownViewRef} style={styles.containerStyle} onLayout={onLayout}>
        <TouchableHighlight
          testID={`${testID}dropdownTouchableID`}
          onPress={dropdownTapped}
          underlayColor="white"
          disabled={disabled}>
          <Box {...styles.container} width={measureInfo?.width}>
            {placeHolder && placeHolder?.length > 0 && !selData.length && (
              <Text type="h4" color={Colors.FONT_BLACK as ColorOptions} fontFamily={fontFamily}>
                {placeHolder}
              </Text>
            )}
            {renderValues()}
            <Icon
              id={disabled ? 'LOCK' : showDropdown ? 'ARROW_UP' : 'ARROW_DOWN'}
              size={disabled ? 12 : 'FONT_SIZE_DOUBLE_LARGE'}
              color={Colors.FONT_BLACK as ColorOptions}
            />
          </Box>
        </TouchableHighlight>
        <ModalView
          hide={showDropdown}
          onDismiss={dismissDropDown}
          data={data}
          selectedData={onSelected}
          measureInfo={measureInfo}
          preSelectedData={selData}
          isMultiSelect={isMultiSelect}
          selectAll={selectAll}
          checkboxColor={checkboxColor}
          width={measureInfo?.width}
          maxHeight={modelMaxHeight}
          fontFamily={fontFamily}
          testId={scrollViewId}
        />
      </View>
      {touched && !!error && (
        <>
          <Spacer size={2} />
          <Text testID={`${testID}textInputErrorId`} color="ERROR" type="h4Bold">
            {error}
          </Text>
        </>
      )}
    </Box>
  )
}

const styles = {
  containerStyle: {
    flex: 1,
  } as ViewStyle,
  container: {
    borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justify: 'space-between',
    paddingLeft: 12,
    paddingRight: 8,
    borderRadius: 4,
    backgroundColor: 'WHITE',
    h: 40,
  } as BoxProps,
  textContainer: {
    flexDirection: 'row',
    paddingHorizontal: 8,
    borderWidth: 1,
    borderRadius: 24,
    marginRight: 8,
    alignItems: 'center',
    // maxWidth: 80,
    w: 80,
    h: 24,
    justify: 'space-between',
  } as BoxProps,
}

export { MultiselectDropdown }
